<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <b-tabs content-class="mt-3">
          <b-tab title="Device handoff" active>
            <form-base
              :submit-status="submitStatus"
              action="Handed Off"
              :errors="errors"
              :loading="loading"
              v-on:handleSubmit="handleSubmit"
            >
              <template v-slot:fields>
                <h3 v-if="job.client">{{ job.client.name }}</h3>

                <div class="border p-2">
                  <div class="row">
                    <div class="col-auto">
                      <span class="bg-primary text-white px-3 font-size-26">
                        {{ job.job_number }}</span
                      >
                    </div>
                    <div class="col">
                      <p class="text-muted mt-2 mb-0" v-if="job.manufacture">
                        {{ job.manufacture.description }} -
                        {{ job.device_type.description }}
                        <span v-if="job.device_model">
                          <br />
                          <strong>{{ job.device_model.code }}</strong> -
                          {{ job.imei_in ? job.imei_in : job.serial_in }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <table class="table-sm table">
                  <tr v-for="invoice in job.invoices" :key="invoice.id">
                    <td>Invoice #{{ invoice.invoice_number }}</td>
                    <td>
                      <b-badge variant="success" v-if="invoice.is_paid == 1"
                        >paid</b-badge
                      >
                      <b-badge variant="warning" v-if="invoice.is_paid == 0"
                        >unpaid</b-badge
                      >
                    </td>
                    <td>
                      {{ invoice.total_amount }}
                    </td>
                  </tr>
                </table>
              </template>
            </form-base>
          </b-tab>

          <b-tab title="Client" v-if="job.client_id">
            <client :id="job.client_id" class="mt-3"></client>
          </b-tab>

          <b-tab v-if="job.partner_id" title="Partner">
            <partner :id="job.partner_id" class="mt-3"></partner>
          </b-tab>

          <b-tab title="Job">
            <job-minimal :id="id"></job-minimal>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import shippingRepo from "@/api/repos/shippingRepo";
import formBase from "@/components/common/FormBase";
import partner from "@/views/modules/partners/show";
import client from "@/views/modules/clients/show";
import jobMinimal from "@/views/modules/jobs/enquiryMinimal";

export default {
  components: {
    formBase,
    partner,
    client,
    jobMinimal,
  },

  props: ["id"],

  mounted() {
    this.getCreatedData(this.id);
  },

  data() {
    return {
      shipping: {},
      job: {},
      loading: false,
      errors: null,
      submitStatus: null,
    };
  },

  methods: {
    async getCreatedData(id) {
      try {
        this.loading = true;
        let { data } = await shippingRepo.handedOffCreate(id);
        this.job = data.job;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";

      try {
        await shippingRepo.handedOffStore(this.job);
        this.$emit("handedOffCreated");
      } catch (error) {
        console.log(error);
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;
          console.log(this.errors);
          this.$root.$bvToast.toast("Form Errors", {
            title: "Errors on form data",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      } finally {
        this.loading = false;
        this.submitStatus = null;
      }
    },
  },
};
</script>

